import React from "react";
import Navbar from "./Navbar/Navbar";

const Home = () => {
  return (
    <>
      <Navbar />
    </>
  );
};

export default Home;
